import { PreloadedQuery } from 'react-relay';

import { createRelayResource, RelayResourceConfig } from '@townsquare/relay-utils';
import type {
	ResourceStoreContext,
	RouterContext,
	RouterDataContext,
	RouteResource,
} from '@townsquare/router/routing-types';
import type { HomeResourceContext } from '@townsquare/router/types';
import { fg } from '@townsquare/stat-sig/gate';

import RovoCleanUpTeamsNudgeQuery, {
	type RovoCleanUpTeamsNudgeQuery as RovoCleanUpTeamsNudgeQueryType,
} from '../components/__generated__/RovoCleanUpTeamsNudgeQuery.graphql';

const getCleanUpTeamsSkillNudgeResourceQuery = (
	_routerContext: RouterContext | RouterDataContext,
	resourceContext: ResourceStoreContext,
): RelayResourceConfig<RovoCleanUpTeamsNudgeQueryType> => {
	const context = resourceContext as HomeResourceContext;
	const accountId = context.user.accountId;
	const isOrgAdmin = context.workspace?.capabilities?.orgAdmin ?? false;

	const userTeamQuery = isOrgAdmin
		? `(isVerifiedTeamFilter != 'true')`
		: `(member = ${accountId}) AND (isVerifiedTeamFilter != 'true')`;

	const isCleanUpTeamsRovoSkillEnabled = fg('enable_clean_up_teams_agentic_skill');

	return {
		query: RovoCleanUpTeamsNudgeQuery,
		variables: {
			organisationId: context.workspace?.organisationId ?? context.orgId ?? '',
			cloudId: (context.collabContext?.rovoWorkspace || context.workspace?.cloudId) ?? 'None',
			userTeamQuery,
			isCleanUpTeamsRovoSkillEnabled,
		},
		options: {
			fetchPolicy: 'store-or-network',
		},
	};
};

export const cleanUpTeamsSkillNudgeResource: RouteResource<
	PreloadedQuery<RovoCleanUpTeamsNudgeQueryType, Record<string, unknown>>
> = createRelayResource<RovoCleanUpTeamsNudgeQueryType>({
	getQuery: getCleanUpTeamsSkillNudgeResourceQuery,
});
